(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  // El `newsletter-popup` del tema és una caixeta que no bloqueja res. Aquí se'n fa una finestra modal:
  // mateix comportament (retard, «només un cop», s'amaga si ja s'ha apuntat), però atrapa el focus, Esc
  // la tanca, la pàgina no es desplaça per sota i l'animació no arrossega el fons fosc.
  customElements.whenDefined('newsletter-popup').then(() => {
    if (customElements.get('mp-newsletter-modal')) return;

    const Base = customElements.get('newsletter-popup');
    const reduirMoviment = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class MpNewsletterModal extends Base {
      get shouldTrapFocus() { return true; }
      get shouldLock() { return true; }

      animar(entrant) {
        // Les animacions velles amb `fill: forwards` deixarien la finestra transparent en tornar-la a obrir.
        this.getAnimations({ subtree: true }).forEach((a) => a.cancel());
        const durada = reduirMoviment() ? 0 : 280;
        const card = this.querySelector('.mp-nl__card');
        const fons = this.animate({ opacity: entrant ? [0, 1] : [1, 0] }, { duration: durada, easing: 'ease', fill: 'forwards' });
        const targeta = card.animate(
          { transform: entrant ? ['translateY(16px) scale(.98)', 'none'] : ['none', 'translateY(8px)'] },
          { duration: durada, easing: 'cubic-bezier(.2, .7, .2, 1)', fill: 'forwards' }
        );
        return {
          finished: Promise.all([fons.finished, targeta.finished]).catch(() => {}),
          finish() { fons.finish(); targeta.finish(); }
        };
      }

      createEnterAnimationControls() { return this.animar(true); }
      createLeaveAnimationControls() { return this.animar(false); }
    }

    customElements.define('mp-newsletter-modal', MpNewsletterModal);
  });

  // El bàner de cookies i aquesta finestra no poden sortir alhora: la persona es quedaria sense poder
  // contestar el consentiment. Mentre el bàner hi sigui, la finestra s'espera; quan ja s'ha decidit, apareix.
  customElements.whenDefined('mp-newsletter-modal').then(() => {
    const popup = document.querySelector('mp-newsletter-modal');
    if (!popup) return;

    const banerObert = () => !!document.querySelector('#shopify-pc__banner');
    let ajornat = false;

    const apartar = () => {
      if (popup.open && banerObert()) {
        popup.hide();
        ajornat = true;
      }
    };

    const vigilant = new MutationObserver(apartar);
    vigilant.observe(popup, { attributes: true, attributeFilter: ['open'] });
    apartar();

    document.addEventListener('visitorConsentCollected', () => {
      vigilant.disconnect();
      if (ajornat) setTimeout(() => popup.show(), 1200);
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-popup"]) return;
  try {
    
  (() => {
    const CLAU = 'mp:pro-popup';
    const CLAU_VISTES = 'mp:pro-popup:vistes';
    const DIA = 864e5;

    const llegir = (magatzem, clau) => { try { return magatzem.getItem(clau); } catch (e) { return null; } };
    const escriure = (magatzem, clau, valor) => { try { magatzem.setItem(clau, valor); } catch (e) {} };

    // Pàgines vistes en aquesta visita (es compten a totes les pàgines, també on no surt).
    const vistes = (parseInt(llegir(sessionStorage, CLAU_VISTES) || '0', 10) || 0) + 1;
    escriure(sessionStorage, CLAU_VISTES, String(vistes));

    class MpProPopup extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-mp-pro-close]').forEach((b) => b.addEventListener('click', () => this.tancar(false)));
        this.querySelector('[data-mp-pro-cta]')?.addEventListener('click', () => this.recordar('fet'));
        this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.tancar(false); });

        if (window.Shopify?.designMode) {
          // A l'editor de temes: es veu quan se selecciona la secció.
          document.addEventListener('shopify:section:select', (e) => { if (this.closest(`#shopify-section-${e.detail.sectionId}`)) this.mostrar(); });
          document.addEventListener('shopify:section:deselect', (e) => { if (this.closest(`#shopify-section-${e.detail.sectionId}`)) this.tancar(true); });
          return;
        }

        if (!this.toca()) return;
        setTimeout(() => this.intentar(), (parseInt(this.dataset.delay, 10) || 0) * 1000);
      }

      toca() {
        // A la fitxa de producte en mòbil hi ha la barra de compra fixa a baix: no s'hi posa al damunt.
        if (this.dataset.template === 'product' && window.matchMedia('(max-width: 699px)').matches) return false;
        if (vistes < (parseInt(this.dataset.minPageviews, 10) || 1)) return false;
        if (llegir(sessionStorage, CLAU + ':vist')) return false; // com a molt un cop per visita
        const desat = JSON.parse(llegir(localStorage, CLAU) || 'null');
        if (!desat) return true;
        if (desat.estat === 'fet') return false;
        const dies = parseInt(this.dataset.snoozeDays, 10) || 30;
        return Date.now() - desat.quan > dies * DIA;
      }

      // No surt mai damunt d'una altra cosa: si hi ha el bàner de cookies o la newsletter, torna-ho a
      // provar d'aquí a una estona.
      intentar(intents = 0) {
        const ocupat = document.querySelector('#shopify-pc__banner, #shopify-pc__prefs[style*="block"], mp-newsletter-modal[open], .drawer[open], x-modal[open]');
        if (ocupat) {
          if (intents < 20) setTimeout(() => this.intentar(intents + 1), 6000);
          return;
        }
        escriure(sessionStorage, CLAU + ':vist', '1');
        this.mostrar();
      }

      mostrar() {
        this.hidden = false;
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-visible')));
      }

      tancar(nomesAmagar) {
        if (!nomesAmagar) this.recordar('tancat');
        this.classList.remove('is-visible');
        setTimeout(() => { this.hidden = true; }, 350);
      }

      recordar(estat) {
        escriure(localStorage, CLAU, JSON.stringify({ estat, quan: Date.now() }));
      }
    }

    if (!customElements.get('mp-pro-popup')) customElements.define('mp-pro-popup', MpProPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mp-shop-the-look')) {
    customElements.define('mp-shop-the-look', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.querySelectorAll('.shop-the-look__hot-spot[data-mp-product-index]').forEach((hotSpot) => {
          hotSpot.addEventListener('click', () => {
            const item = hotSpot.closest('.shop-the-look__item');
            const index = hotSpot.dataset.mpProductIndex;
            this.selectProduct(item, index);
            item.querySelector(`.shop-the-look__product-row[data-mp-product-index="${index}"]`)?.scrollIntoView({
              block: 'nearest',
              inline: 'nearest',
              behavior: reducedMotion.matches ? 'auto' : 'smooth'
            });
          }, options);
        });

        this.querySelectorAll('.shop-the-look__product-row[data-mp-product-index]').forEach((row) => {
          const toggleHotSpot = (active) => {
            const item = row.closest('.shop-the-look__item');
            item.querySelector(`.shop-the-look__hot-spot[data-mp-product-index="${row.dataset.mpProductIndex}"]`)?.classList.toggle('is-linked', active);
          };

          row.addEventListener('pointerenter', () => toggleHotSpot(true), options);
          row.addEventListener('pointerleave', () => toggleHotSpot(false), options);
          row.addEventListener('focus', () => toggleHotSpot(true), options);
          row.addEventListener('blur', () => toggleHotSpot(false), options);
        });
      }

      disconnectedCallback() {
        this.abortController.abort();
      }

      selectProduct(item, index) {
        item.querySelectorAll('.shop-the-look__hot-spot[data-mp-product-index]').forEach((hotSpot) => {
          hotSpot.setAttribute('aria-current', hotSpot.dataset.mpProductIndex === index ? 'true' : 'false');
        });
        item.querySelectorAll('.shop-the-look__product-row[data-mp-product-index]').forEach((row) => {
          row.classList.toggle('is-active', row.dataset.mpProductIndex === index);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
